import { TRUST_ITEMS } from "../../data/content";
import { FadeUp } from "./ui";

const TrustStrip = () => (
  <section className="border-y border-line bg-ink" data-testid="trust-strip">
    <FadeUp y={16} duration={0.6}>
      <div className="no-scrollbar mx-auto flex max-w-[1440px] items-stretch overflow-x-auto px-6 md:justify-between md:px-12 lg:px-20">
        {TRUST_ITEMS.map((item, i) => (
          <div
            key={item}
            className={`flex shrink-0 items-center py-7 ${
              i > 0 ? "border-l border-line pl-8 ml-8 md:pl-10 md:ml-0 md:border-l-0" : ""
            } md:flex-1 md:justify-center ${i > 0 ? "md:border-l" : ""}`}
          >
            <span className="whitespace-nowrap font-display text-[10px] font-medium tracking-[0.18em] text-neutral-400">
              {item}
            </span>
          </div>
        ))}
      </div>
    </FadeUp>
  </section>
);

export default TrustStrip;
